export default __webpack_public_path__ + "e75f1d7e99b41be2360ea1bc1cb5d2ce.png";